<template>
    <div class="my-courses">
        <!-- Header -->
        <div class="header">
            <div class="inner-color">
                <img @click="back" class="back" :src="Back" alt="Back">
                <p>دوره‌های من</p>
            </div>
        </div>

        <!-- Content -->
        <div class="content">
            <!-- Item List -->
            <div class="list-container">
                <div class="item-list">
                    <span class="active">همه موارد</span>
                </div>
            </div>

            <div class="container out-container">
                <div class="row">
                    <p v-if="!List.length">در حال حاضر دوره‌ای یافت نگردید.</p>
                    <template v-else>
                        <div class="col-6 col-md-4 col-lg-3 item" v-for="(item, index) in List" :key="index">
                            <div class="inner-container">
                                <router-link
                                    class="inner-item"
                                    :style="{ 'background-image': 'linear-gradient(180deg, #666a 100%, transparent), url(' + URL + '/' + item.Cover + ')' }"
                                    tag="div" :to="{ name: 'BaseCourse', params: { course: item._id } }"
                                >
                                    <span>{{ item.Title }}</span>
                                </router-link>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Back from '@/assets/images/courses/details/back.png';

import { getRequest, APP_API_URL } from '@/utils/libs/api-request';
// import Cookies from 'js-cookie';

// import moment from 'moment';

export default {
    name: 'MyCourses',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    data() {
        return {
            Back: Back,

            URL: APP_API_URL(),
            prevRoute: {},

            List: []
        }
    },
    mounted() {
        this.getCurrent()
    },
    methods: {
        getCurrent() {
            getRequest('/users/get-courses')
                .then(rsp => {
                    // response
                    this.List = rsp['data'].UserCourses;
                })
                .catch(() => {
                    // error
                });
        },
        back() {
            if(this.prevRoute.name) {
                this.$router.go(-1)
            } else {
                this.$router.push({ name: 'Khanesh' })
            }
        }
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- GENERAL --------------- */
/* ---------------------------------------- */
.my-courses {
    min-height: 100vh;
}

/* ---------------------------------------- */
/* ---------------- HEADER ---------------- */
/* ---------------------------------------- */
.my-courses .header {
    height: calc(60pt + 9vh);
    width: 100vw;
    margin-bottom: -9vh;

    position: relative;
    overflow: hidden;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.my-courses .header .back {
    height: 25pt;

    position: absolute;
    top: 15pt;
    right: 10pt;

    cursor: pointer;
}
.my-courses .header .inner-color {
    height: 100%;
    width: 100%;

    color: #fff;
    background-color: #24327c;
}
.my-courses .header .inner-color p {
    font-weight: bold;
    position: absolute;
    top: 15pt;
    right: 40pt;

    line-height: 1.5rem;
    margin: calc(20pt - 1.5rem) 0;
}

/* ---------------------------------------- */
/* ---------------- RESULT  --------------- */
/* ---------------------------------------- */
.content .out-container {
    padding-top: 25pt;
}
.content .item {
    height: 100%;
    width: 100%;

    margin-bottom: 5pt;
    padding: 0 5pt;
}
.content .item .inner-container {
    height: 100%;
    width: 100%;

    padding: 7pt;
    border: 1px solid #ffffff;
    border-radius: 20pt;
    box-shadow: inset 4.2px 4.2px 3px 0 #cecece;
}
.content .item .inner-container .inner-item {
    height: 40vh;
    width: 100%;
    padding: 10pt;

    border-radius: 15pt;
    /* background-color: #242427; */
    /* box-shadow: 4.2px 4.2px 3px 0 #24242744; */
    border: 1px solid #cfcfcf;
    background-color: #fff;
    box-shadow: 4.2px 4.2px 3px 0 #24242744;

    text-align: center;
    cursor: pointer;
    display: flex;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.content .item .inner-container .inner-item span {
    margin: auto;
    display: inline-block;
    color: #fff;
}

/* ---------------------------------------- */
/* -------------- ITEMS LIST -------------- */
/* ---------------------------------------- */
.my-courses .list-container {
width: calc(100% - 18vh);
    min-height: 2.5rem;
    margin: 0 9vh;

    overflow: scroll;
    background-color: #ebecf1;
}
.my-courses .item-list {
    width: max-content;
    padding: 0 10pt;
}
.my-courses .item-list span {
    height: 100%;
    margin: auto 10pt;
    padding: 5pt 7pt;

    display: inline-block;
    vertical-align: sub;

    cursor: pointer;
    color: #86888e;
    border-top: 3px solid #ebecf1;
}
.my-courses .item-list span.active,
.my-courses .item-list span:hover,
.my-courses .item-list span:active {
    font-weight: bold;
    color: #373b48;
    border-top: 3px solid #ed412c;
}
@media (max-width: 576px) {
    .my-courses .item-list span {
        font-size: .8rem;
    }
    .my-courses .item-list {
        padding: 0 5pt;
    }
    .my-courses .item-list span {
        margin: auto 5pt;
    }
}

/* ---------------------------------------- */
/* ---------------- CONTENT --------------- */
/* ---------------------------------------- */
.my-courses .content {
    min-height: calc(100vh - 60pt);
    background-color: #ebecf1;

    display: flex;
    flex-direction: column;

    border-top-right-radius: 9vh;
    border-top-left-radius: 9vh;

    position: relative;
}
.my-courses .content p {
    margin: 1rem auto;
}
</style>